module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento10.4bcc5dc2.svg";